import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PdfLinkActions from "src/components/PdfLinkActions";

export default function Step2({ id, shipmentId, projectId, onClose }) {
  const handleViewInboundShipment = () => {
    if (!id || !shipmentId) return;

    const url = `/projects/${projectId}/capture-inventory?info=true&step=items&receiving=true&editShipment=true&shipmentId=${shipmentId}&id=${id}`;
    window.location.href = url;
  };

  return (
    <>
      <IconButton onClick={onClose} size="small" style={{ position: "absolute", top: 8, right: 8 }}>
        <CloseIcon />
      </IconButton>
      <Box mb={2}>
        <Typography fontWeight={500} fontSize={20}>
          Onsite Inventory to Warehouse Receiving
        </Typography>
      </Box>
      <Typography variant="body1" paragraph sx={{ my: 10 }}>
        I created your new preliminary receiving report. The warehouse team will complete it once
        they receive the items.
      </Typography>

      <Box mt={4} display="flex" gap={2}>
        <PdfLinkActions
          resourceType="shipment_pdfs"
          resourceId={id}
          label="View Receiving Report"
          variant="outlined"
          color="primary"
          fullWidth
          sx={{ flex: 1, fontSize: 14 }}
        />
        <PdfLinkActions
          resourceType="shipment_items_pdfs"
          resourceId={id}
          label="Print Labels"
          extraQueryParams={{
            item_lables_count_by: "rack_location",
            label_type: "full_label_with_move_label",
          }}
          variant="contained"
          color="primary"
          fullWidth
          sx={{ flex: 1, fontSize: 14 }}
        />
      </Box>
    </>
  );
}
